import { render, staticRenderFns } from "./RegionCascader.vue?vue&type=template&id=228ca0ee"
import script from "./RegionCascader.vue?vue&type=script&lang=js"
export * from "./RegionCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports